import { useAppData } from "eddev/hooks"
import { MenuLocationEnum } from "../types.graphql"

export function useMenu(location: keyof typeof MenuLocationEnum) {
  const menus = useAppData((appData) => appData.menus?.nodes)
  const menu = menus?.find((menu) => menu?.locations?.includes(MenuLocationEnum[location]))

  return menu
}
